import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import { Grid, MenuItem, Button } from '@material-ui/core';
import { InputField } from '..';

import { useStyles } from './styles.js';

class FantasySettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      ready: false,
      values: {
        game_settings: {
          fantasy_pool_size: null,
        },
        fantasy_categories: [],
      },
    };
  }

  /** LIFE CYCLE METHODS */
  componentDidMount() {
    if(this.props.chapter_settings && this.props.current_tab){
      const chapter_settings = this.props.chapter_settings;
      const index = this.props.current_tab;
      if(chapter_settings[index] && chapter_settings[index].game_settings){
        const game_settings = chapter_settings[index].game_settings;
        this.setState({
          values: {
            game_settings: game_settings,
            fantasy_categories: game_settings.category,
          }
        })
      }
    }
  }

  handleChange = (e, val, index) => {
    if (val == 'fantasy_categories') {
      let values = {...this.state.values};
      let fantasy_categories = values['fantasy_categories'].slice();
      fantasy_categories[index] = {
        ...fantasy_categories[index],
        name: e.target.value,
      };
      values['fantasy_categories'] = fantasy_categories;
      this.setState({
        values,
      });
    } else if (val == 'number_of_categories') {
      let target_value = e.target.value == null || e.target.value == '' ? 0 : e.target.value;
      let values = this.state.values;
      values['game_settings']['number_of_categories'] = e.target.value;
      values['fantasy_categories'] = Array(parseInt(target_value)).fill({
        quarter_id: this.props.current_tab,
        name: '',
      });
      this.setState({
        values,
      });
    } else if (val) {
      let values = this.state.values;
      if (e.target.name == 'fantasy_pool_size') {
        values['game_settings']['randomization'] =
          e.target.value > 12 ? true : false;
      }
      values['game_settings'][e.target.name] = e.target.value;
      this.setState({ values });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  /**RENDER METHOD */
  render() {
    const { classes, isEdit } = this.props;
    let fantasy_view_type_id;
    if(this.props.chapter_settings && this.props.chapter_settings[this.props.current_tab]){
      let tab = this.props.chapter_settings[this.props.current_tab];
      if(tab.game_settings) fantasy_view_type_id = tab.game_settings.fantasy_view_type_id;
    }
    return (
      <Grid>
        <Grid container className={classes.gridContainer}>
          <Grid item md={6} xs={12}>
            <InputField
              label={'Pool Size'}
              id="fantasy_pool_size"
              name="fantasy_pool_size"
              className={classes.field}
              onChange={e => {
                this.handleChange(e, 'values');
              }}
              value={this.state.values.game_settings.fantasy_pool_size}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <InputField
              select
              label={'Frontend View'}
              id="fantasy_view_type_id"
              name="fantasy_view_type_id"
              className={classes.field}
              onChange={e => {
                this.handleChange(e, 'values');
              }}
              value={this.state.values.game_settings.fantasy_view_type_id ? this.state.values.game_settings.fantasy_view_type_id : fantasy_view_type_id}
            >
              <MenuItem value={2}>Simple Slider</MenuItem>
              <MenuItem value={3}>Groupwise View</MenuItem>
              <MenuItem value={4}>Tiered View</MenuItem>
            </InputField>
          </Grid>
          <Grid item md={6} xs={12}>
            <InputField
              label={'Draft Size'}
              id="number_of_allowed_selections"
              name="number_of_allowed_selections"
              className={classes.field}
              onChange={e => {
                this.handleChange(e, 'values');
              }}
              value={
                this.state.values.game_settings.number_of_allowed_selections
              }
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <InputField
              label={'Number Of Categories'}
              id="number_of_categories"
              name="number_of_categories"
              className={classes.field}
              onChange={e => {
                this.handleChange(e, 'number_of_categories');
              }}
              value={this.state.values.game_settings.number_of_categories}
            />
          </Grid>

          {this.state.values.fantasy_categories.map((category, index) => {
            return (
              <Grid item md={6} xs={12}>
                <InputField
                  label={`Category ${index + 1}`}
                  id="fantasy_categories"
                  name="fantasy_categories"
                  className={classes.field}
                  onChange={e => {
                    this.handleChange(e, 'fantasy_categories', index);
                  }}
                  value={
                    this.state.values.fantasy_categories[index] &&
                    this.state.values.fantasy_categories[index].name
                  }
                />
              </Grid>
            );
          })}
        </Grid>
        {
        !isEdit &&
        <Button
          color="primary"
          type="button"
          variant="contained"
          onClick={e => this.props.onClick(this.state.values)}
        >
          Next
        </Button>
        }
      </Grid>
    );
  }
}

FantasySettings.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(FantasySettings);
